import React, { useState } from "react";
import { Modal } from "react-bootstrap";
import Resources from "../../types/Resources";
import InformationAlert from "../Common/InformationAlert";
import TextArea from "../Common/TextArea";
import { formElement } from "../../types/forms/FormElement";
import Button from "../Common/Button";

type RejectPermitModalProps = {
    show: boolean;
    onHide: () => void;
    resources: Resources;
    onReject: (comment: string) => void;
};

function RejectPermitModal({ show, onHide, resources, onReject }: RejectPermitModalProps) {
    const [rejectionCommentFormElement, setRejectionCommentFormElement] = useState(formElement(""));

    function rejectButtonClickHandler() {
        if (!rejectionCommentFormElement.value) {
            setRejectionCommentFormElement((prevValue) => ({
                ...prevValue,
                errorMessage: resources.get("YouMustProvideAComment")
            }));
            return;
        }

        onReject(rejectionCommentFormElement.value);
        setRejectionCommentFormElement((prevValue) => ({ ...prevValue, errorMessage: "" }));
    }

    return (
        <Modal onHide={onHide} show={show}>
            <Modal.Header closeButton>
                <h1 className="h5">{resources.get("RejectPermit")}</h1>
            </Modal.Header>
            <Modal.Body>
                <InformationAlert>{resources.get("RejectPermitInfo")}</InformationAlert>
                <TextArea
                    errorMessage={rejectionCommentFormElement.errorMessage}
                    value={rejectionCommentFormElement.value}
                    textAreaId="reject-permit__comment"
                    labelText={resources.get("Comment")}
                    onChange={(s) => setRejectionCommentFormElement((prevValue) => ({ ...prevValue, value: s }))}
                    containerClassName="mb-2"
                    readOnly={false}
                />
                <Button onClick={rejectButtonClickHandler} variant="danger">
                    {resources.get("Reject")}
                </Button>
            </Modal.Body>
        </Modal>
    );
}

export default RejectPermitModal;
